import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {objectGroupApi, ObjectGroupsFilterQuery} from "../api/objectGroupApi"
import {WSObjectGroup} from "../types/WebSocketTypes"
import {ObjectGroupResponse, ObjectGroupsResponse} from "../models/response"

export type ObjectGroupsFilter = {
    limit: number
    offset: number
    status?: "-1" | "0" | "1"
    search?: string
}

type InitialStateType = {
    objectGroups: null | ObjectGroupsResponse
    objectGroup: null | ObjectGroupResponse
    filter: ObjectGroupsFilter & ObjectGroupsFilterQuery
    sideFilter: ObjectGroupsFilter
    ws: WSObjectGroup | null
}

const initialState: InitialStateType = {
    objectGroups: null,
    objectGroup: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    sideFilter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const objectGroupReducer = createSlice({
    name: 'objectGroupReducer',
    initialState,
    reducers: {
        setObjectGroups(state, {payload}) {
            state.objectGroups = payload
        },
        setObjectGroup(state, {payload}) {
            state.objectGroup = payload
        },
        addObjectGroup(state, {payload}) {
            if (state.objectGroups) {
                state.objectGroups = {
                    total: state.objectGroups.total += 1,
                    data: [payload, ...state.objectGroups.data],
                }
            }
        },
        editObjectGroup(state, {payload}: PayloadAction<ObjectGroupResponse>) {
            let index = state.objectGroups?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.objectGroups) state.objectGroups.data[index] = payload
            if (state.objectGroup) state.objectGroup = payload
        },
        setObjectGroupsFilter(state, {payload}) {
            state.filter = payload
        },
        setObjectGroupSideFilter(state, {payload}) {
            state.sideFilter = payload
        },
        setWSObjectGroup(state, {payload}: PayloadAction<WSObjectGroup | null>) {
            state.ws = payload
        },
    },
})

export const {setObjectGroups, setObjectGroup, addObjectGroup, editObjectGroup, setObjectGroupsFilter, setObjectGroupSideFilter, setWSObjectGroup} = objectGroupReducer.actions

export default objectGroupReducer.reducer

export const getObjectGroups = asyncCreator
('objectGroupReducer/getObjectGroups', objectGroupApi.getObjectGroups, setObjectGroups)

export const getObjectGroup = asyncCreator
('objectGroupReducer/getObjectGroup', objectGroupApi.getObjectGroup, setObjectGroup)

export const createObjectGroup = asyncCreator
('objectGroupReducer/createObjectGroup', objectGroupApi.createObjectGroup, addObjectGroup)

export const changeObjectGroup = asyncCreator
('objectGroupReducer/changeObjectGroup', objectGroupApi.changeObjectGroup, editObjectGroup)

export const deleteObjectGroup = asyncCreator
('objectGroupReducer/deleteObjectGroup', objectGroupApi.deleteObjectGroup)